<template>
  <div class="order-items-table">
    <div class="table-search order info" :class="{lab_employee_table: role === 'lab_employee'}">
      <div class="table-header">
        <div class="table-item">
          <div>№ изделия<br></div>
        </div>
        <div class="table-item photos-item">
          <div>Зубы | Челюсти<br></div>
        </div>
        <div class="table-item">
          <div>Тип изделия | материал<br></div>
        </div>
        <div class="table-item" v-if="role !== 'lab_employee'" >
          <div>стоимость<br></div>
        </div>
      </div>

      <div
        class="order-item"
        v-for="(product, i) in products"
        :key="i"
      >
        <div class="table-item">
          <div class="item-title">Изделие №{{ i + 1 }}<br></div>
        </div>

        <div class="table-item">
          <div>
            {{ formattedTeeth(product.teeth) }}
          </div>
        </div>

        <div class="table-item">
          <div>{{typeText(product)}}<br></div>
          <div class="text-secondary" v-if="product.additional_info">
            {{additionalText(product)}}
          </div>
        </div>

        <div class="table-item" v-if="role !== 'lab_employee'">
          <div >
            {{displayedPrice(product.price)}}
            <span class="text-secondary">
              ({{parseInt(product.price)/product.teeth.length}} ₽/ед)
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import addSpaces from '@/utils/formatting/add-spaces';
  import formatDate from '@/utils/formatting/format-date';
  import declOfNum from '@/utils/formatting/decl-of-num';
  import {ADDITIONS, TYPES} from '@/utils/constants/order-types';
  import {mapState } from 'vuex';
  import {NUMBERS} from '@/utils/constants/teeth-svgs';
  import {getBridgetTeeth} from '@/utils/formatting/list-teeth';

  const TOP_JAW_INDEX = 33;
  const BOTTOM_JAW_INDEX = 34;

  export default {
    name: 'OrderInfo',
    props: {
      order: {
        type: Object,
        required: true,
      },
      hidePrice: Boolean,
      hideReadyDate: Boolean,
    },
    computed: {
      ...mapState({
        types: state => state.global.types,
        role: state => state.auth?.user?.role || '',
      }),
      products () {
        return this.order.products || [];
      },
      price () {
        return addSpaces(this.order.full_price);
      },
      dates () {
        const ready = this.hideReadyDate ? '' : `, будет готов ${formatDate(this.order.deadline)}`;
        return `Создан ${formatDate(this.order.status_change_date)}${ready}`;
      },
      type () {
        const type = (TYPES.find(type => type.slug === this.products[0].type) || {}).name || '';
        const add = this.products[0].additional_info
          ? (ADDITIONS.find(add => add.slug === this.products[0].additional_info) || {}).text || ''
          : '';
        return type + (add ? ', ' + add : '');
      },
      material () {
        return this.products[0].material ? this.products[0].material.toUpperCase() : '';
      },
      forWhat () {
        let suffix;
        if (this.products[0].teeth.some(tooth => parseInt(tooth.type) === 33) || this.products[0].teeth.some(tooth => parseInt(tooth.type) === 34))
          suffix = declOfNum(this.products[0].teeth.length, ['челюсть', 'челюсти', 'челюстей']);
        else suffix = declOfNum(this.products[0].teeth.length, ['зуб', 'зуба', 'зубов']);
        return `Стоимость за ${this.products[0].teeth.length} ${suffix}`;
      },

      bridges () {
        const bridgeArrs = (this.order.products || []).map(product => product.bridges.map(bridge => bridge.teeth.map(tooth => tooth.type))).flat();
        const bridges = bridgeArrs.map(bridgeArr => bridgeArr.filter((element, index) => index < bridgeArr.length - 1)).flat();

        if (bridges.includes(8) && !bridges.includes(9)) bridges.push(9);
        if (bridges.includes(9) && !bridges.includes(8)) bridges.push(8);
        if (bridges.includes(24) && !bridges.includes(25)) bridges.push(25);
        if (bridges.includes(25) && !bridges.includes(24)) bridges.push(24);

        bridges.sort((a, b) => a - b);
        return bridges;
      },
    },
    methods: {
      formattedTeeth (data) {
        const teeth = data.slice().sort((a, b) => a.type - b.type);

        let res = '';
        const allTeeth = teeth.map(tooth => ({index: tooth.type, bridged: this.bridges.includes(tooth.type)}));
        const unitedTeeth = getBridgetTeeth(allTeeth).map(bridge => bridge.bridged ? `Мост ${NUMBERS[bridge.indexes[0]].num}-${NUMBERS[bridge.indexes[bridge.indexes.length - 1]].num}` : NUMBERS[bridge.indexes[0]].num).join('; ');
        res += unitedTeeth;

        return res;
      },
      typeText (product) {
        let res = '';
        res = res + this.types.find(el => el.slug === product.type).name;
        if (product.material) res = res + ', ' + product.material.toUpperCase();
        return res;
      },
      additionalText (product) {
        let res = '';
        if (product.additional_info) {
          const additional = this.types.find(el => el.slug === product.type)?.additional;
          if (additional?.type === 'radio') {
            res = additional.options.find(el => el.slug === product.additional_info).text;
          } else if (additional.type === 'check') {
            res = product.additional_info === additional.slug ? additional.text : '';
          }
        }
        return res;
      },
      displayedPrice (price) {
        return addSpaces(price) + ' ₽';
      },
    },
  };
</script>

<style>
  .order-item {
    display: contents !important; /*MYSTYLE*/
  }

  .lab_employee_table {
    grid-template-columns: auto auto auto !important;
  }

  .order-detail-wrap .table-search.order .table-item {
    padding-bottom: 4px;
    padding-top: 4px;
  }

  .order-item .table-item:first-child {
    border-radius: 8px 0 0 8px;
  }

  @media screen and (max-width: 991px) {
    .order-item {
      display: flex !important;
    }
  }

  @media screen and (max-width: 479px) {
    .order-item {
      flex-direction: column;
    }
  }

</style >
